import {
	Notification
} from '../reducers/notifications';

interface AsyncAction {
	type: string;
	promise: Promise<any>
}

interface Action {
	type: string;
	payload: any;
}

export const NEW_NOTIFICATION = "NEW_NOTIFICATION";
export function newNotifcation(notification: Notification): Action {
	return {
		type: NEW_NOTIFICATION,
		payload: notification
	}
}

export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export function removeNotification(): Action {
	return {
		type: REMOVE_NOTIFICATION,
		payload: null
	}
}